/**
 * Admin V3 — Module placeholder card
 *
 * Phase 1: every module route renders this. Mirrors the M1 "Bientôt
 * disponible" pattern but with module-aware title resolved from i18n.
 *
 * Special cases:
 *   - moduleKey "notFound" renders the 404 placeholder (catch-all route).
 *   - When `detailId` prop is provided, renders the detail-page variant
 *     showing "Module: <id>" so owner can verify route param plumbing.
 *
 * Visual: white SectionCard (legacy rounded-[24px]) + EmptyState (legacy
 * muted layout). No new design tokens introduced.
 */

import React from 'react';
import { Clock, FileQuestion } from 'lucide-react';
import { SectionCard, EmptyState } from '../visualTokens';
import { t } from '../../i18n';

const ModulePlaceholder = ({ moduleKey, detailId, locale = 'fr' }) => {
  // Catch-all 404
  if (moduleKey === 'notFound') {
    return (
      <SectionCard
        title={t('placeholder.notFound.title', locale)}
        icon={FileQuestion}
        iconClass="bg-slate-100 text-slate-600"
      >
        <EmptyState
          icon={FileQuestion}
          title={t('placeholder.notFound.title', locale)}
          desc={t('placeholder.notFound.desc', locale)}
        />
      </SectionCard>
    );
  }

  // Detail-page variant — shows the URL param so plumbing is visible
  if (detailId) {
    const moduleLabel = t(`nav.${moduleKey.replace(/\.detail$/, '')}`, locale);
    return (
      <SectionCard
        title={`${moduleLabel}: ${detailId}`}
        icon={Clock}
        iconClass="bg-slate-100 text-slate-600"
      >
        <EmptyState
          icon={Clock}
          title={t('placeholder.module.title', locale)}
          desc={t('placeholder.detail.desc', locale)}
        />
      </SectionCard>
    );
  }

  // Default placeholder
  const title = t(`nav.${moduleKey}`, locale);
  return (
    <SectionCard
      title={title}
      icon={Clock}
      iconClass="bg-slate-100 text-slate-600"
    >
      <EmptyState
        icon={Clock}
        title={t('placeholder.module.title', locale)}
        desc={t('placeholder.module.desc', locale)}
      />
    </SectionCard>
  );
};

export default ModulePlaceholder;
